export default "__VITE_ASSET__C39jW5ax__"